import { mapActions, mapGetters } from 'vuex'
import { getAllAdmins } from 'src/api/admins'
import { findIndex } from 'lodash'
export default {
  data () {
    return {
      submitting: false,
      localRole: {
        name: '',
        display_name: '',
        description: '',
        users: [],
        permissions: []
      },
      suggettionAdmin: {},
      fetchAdmin: false,
      listAdmins: [],
      selectedAdmins: [],
      rules: {
        name: [
          {required: true, message: 'Bạn chưa nhập tên role', trigger: 'change'},
          {max: 255, message: 'Tên role phải nhỏ hơn 255 ký tự', trigger: 'change'}
        ]
      },
      listPermissions: []
    }
  },
  computed: {
    ...mapGetters('permission', ['permissions'])
  },
  methods: {
    ...mapActions('permission', ['getAllPermissions']),
    selectPermission (e, permission) {
      if (e.target.checked) {
        if (findIndex(this.listPermissions, {id: permission.id}) < 0) {
          this.listPermissions.push({id: permission.id, name: permission.name})
        }
      } else {
        this.listPermissions.splice(findIndex(this.listPermissions, {id: permission.id}), 1)
      }
    },
    checkIsExist (permission) {
      let check = findIndex(this.listPermissions, {id: permission.id})
      if (check < 0) {
        return false
      }
      return true
    },
    selectAdmin (q) {
      if (q) {
        this.fetchAdmin = true
        getAllAdmins({limit: 10, q: q}).then(response => {
          if (response.code === 200) {
            this.listAdmins = response.data
            this.fetchAdmin = false
          }
        })
      }
    },
    selectSuggettionAdmin () {
      if (this.localRole.users.indexOf(this.suggettionAdmin.id) === -1) {
        this.localRole.users.push(this.suggettionAdmin.id)
      }
      if (findIndex(this.selectedAdmins, {id: this.suggettionAdmin.id}) === -1) {
        this.selectedAdmins.push(this.suggettionAdmin)
      }
      this.listAdmins = []
    },
    removeAdmin (admin) {
      this.selectedAdmins.splice(findIndex(this.selectedAdmins, admin), 1)
      this.localRole.users.splice(this.localRole.users.indexOf(admin.id), 1)
    },
    newRole () {
      this.localRole = {
        name: '',
        display_name: '',
        description: '',
        users: [],
        permissions: []
      }
    }
  },
  mounted () {
    this.newRole()
    if (!this.permissions.length) {
      this.getAllPermissions({limit: -1})
    }
    this.listPermissions = []
  },
  watch: {
    localRole: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/role/mixins/index.js